import script from "./BelongsToField.vue?vue&type=script&setup=true&lang=js"
export * from "./BelongsToField.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/Users/crynobone/Projects/laravel/nova/aries/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"BelongsToField.vue"]])

export default __exports__